export function shutdownIntercom() {
  if (window.Intercom) {
    window.Intercom('shutdown');
    window.intercomSettings = undefined;
  }
}
